import React, { useState } from "react";

/* =========================================================
   MOCK DATA
========================================================= */
const INITIAL_FEES = [
  { id: 1, name: "Aarav Sharma", class: "10-A", roll: "101", totalFee: 50000, paidAmount: 50000, status: "Paid", dueDate: "2023-10-15", method: "UPI" },
  { id: 2, name: "Priya Patel", class: "10-A", roll: "102", totalFee: 50000, paidAmount: 25000, status: "Partial", dueDate: "2023-10-15", method: "Cash" },
  { id: 3, name: "Rohan Gupta", class: "10-A", roll: "103", totalFee: 50000, paidAmount: 0, status: "Unpaid", dueDate: "2023-10-15", method: "-" },
  { id: 4, name: "Ananya Singh", class: "10-B", roll: "104", totalFee: 55000, paidAmount: 55000, status: "Paid", dueDate: "2023-10-15", method: "Card" },
  { id: 5, name: "Kabir Verma", class: "10-B", roll: "105", totalFee: 55000, paidAmount: 15000, status: "Partial", dueDate: "2023-10-15", method: "UPI" },
  { id: 6, name: "Ishita Reddy", class: "10-A", roll: "106", totalFee: 50000, paidAmount: 50000, status: "Paid", dueDate: "2023-10-15", method: "Net Banking" },
  { id: 7, name: "Arjun Nair", class: "10-C", roll: "107", totalFee: 45000, paidAmount: 0, status: "Unpaid", dueDate: "2023-10-15", method: "-" },
  { id: 8, name: "Sneha Joshi", class: "10-C", roll: "108", totalFee: 45000, paidAmount: 45000, status: "Paid", dueDate: "2023-10-15", method: "UPI" },
];

const FeeManagement = () => {
  const [feeData] = useState(INITIAL_FEES);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterClass, setFilterClass] = useState("All");
  const [filterStatus, setFilterStatus] = useState("All");

  // Filter Logic
  const filteredData = feeData.filter((student) => {
    const matchesSearch = student.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          student.roll.includes(searchTerm);
    const matchesClass = filterClass === "All" || student.class === filterClass;
    const matchesStatus = filterStatus === "All" || student.status === filterStatus;
    return matchesSearch && matchesClass && matchesStatus;
  });

  // Calculate Stats
  const totalExpected = feeData.reduce((acc, curr) => acc + curr.totalFee, 0);
  const totalCollected = feeData.reduce((acc, curr) => acc + curr.paidAmount, 0);
  const totalPending = totalExpected - totalCollected;
  const paidCount = feeData.filter((s) => s.status === "Paid").length;

  // Format Currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Get Status Color Class
  const getStatusColor = (status) => {
    if (status === "Paid") return "status-paid";
    if (status === "Partial") return "status-partial";
    return "status-unpaid";
  };

  return (
    <>
      {/* 
        =========================================================
        INLINE STYLES 
        =========================================================
      */}
      <style>{`
        @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css");
        @import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap");

        .fee-page {
          font-family: "Plus Jakarta Sans", sans-serif;
          background-color: #f8fafc;
          min-height: 100vh;
          padding: 40px 20px;
          color: #0f172a;
        }

        .fee-container {
          max-width: 1100px;
          margin: 0 auto;
        }

        /* ---------- HEADER ---------- */
        .fee-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 20px;
        }

        .fee-header h1 {
          font-size: 28px;
          font-weight: 700;
          margin: 0 0 6px 0;
          color: #0f172a;
        }

        .fee-header p {
          margin: 0;
          color: #64748b;
          font-size: 15px;
        }

        .header-actions {
          display: flex;
          gap: 12px;
          align-items: center;
        }

        .btn-primary {
          background: #18181b;
          color: #fff;
          border: none;
          padding: 10px 24px;
          border-radius: 12px;
          font-family: inherit;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .btn-primary:hover {
          background: #27272a;
          transform: translateY(-1px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        /* ---------- STATS CARDS ---------- */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .stat-card {
          background: #ffffff;
          padding: 20px;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 16px;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .stat-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
        }

        .stat-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
        }

        .stat-card.expected .stat-icon { background: #e0e7ff; color: #4338ca; }
        .stat-card.collected .stat-icon { background: #dcfce7; color: #166534; }
        .stat-card.pending .stat-icon { background: #fee2e2; color: #991b1b; }
        .stat-card.paid-count .stat-icon { background: #e0f2fe; color: #0369a1; }

        .stat-info {
          display: flex;
          flex-direction: column;
        }

        .stat-info span {
          font-size: 13px;
          color: #64748b;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .stat-info strong {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
          line-height: 1;
        }

        /* ---------- TABLE CONTROLS ---------- */
        .table-controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          gap: 16px;
          flex-wrap: wrap;
        }

        .search-box {
          display: flex;
          align-items: center;
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 0 16px;
          flex: 1;
          max-width: 350px;
          transition: border-color 0.2s;
        }

        .search-box:focus-within {
          border-color: #18181b;
        }

        .search-box .fa {
          color: #64748b;
          font-size: 14px;
        }

        .search-box input {
          border: none;
          background: transparent;
          padding: 12px 10px;
          width: 100%;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          outline: none;
        }

        .filters-group {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
        }

        .filter-box {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #64748b;
        }

        .filter-box select {
          padding: 10px 14px;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          font-size: 14px;
          color: #0f172a;
          background: #ffffff;
          outline: none;
          cursor: pointer;
        }

        /* ---------- DATA TABLE ---------- */
        .table-responsive {
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e2e8f0;
          overflow-x: auto;
          box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        }

        .fee-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
        }

        .fee-table th {
          padding: 16px 20px;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }

        .fee-table td {
          padding: 16px 20px;
          font-size: 14px;
          border-bottom: 1px solid #e2e8f0;
          vertical-align: middle;
        }

        .fee-table tbody tr:last-child td {
          border-bottom: none;
        }

        .fee-table tbody tr:hover {
          background: #f8fafc;
        }

        .roll-col {
          font-weight: 600;
          color: #64748b;
          width: 80px;
        }

        .name-col {
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: #e2e8f0;
          color: #475569;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 700;
        }

        .amount-col {
          font-weight: 600;
          color: #0f172a;
        }
        
        .amount-col.pending-amt {
          color: #991b1b;
        }

        /* Status Badges */
        .status-badge {
          display: inline-flex;
          align-items: center;
          padding: 4px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 600;
        }

        .status-badge.status-paid { background: #dcfce7; color: #166534; }
        .status-badge.status-partial { background: #fef9c3; color: #854d0e; }
        .status-badge.status-unpaid { background: #fee2e2; color: #991b1b; }

        /* Action Button */
        .btn-action {
          background: transparent;
          border: 1px solid #e2e8f0;
          color: #64748b;
          padding: 6px 12px;
          border-radius: 8px;
          font-family: inherit;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
        }

        .btn-action:hover {
          background: #18181b;
          color: #fff;
          border-color: #18181b;
        }

        .no-data {
          text-align: center;
          padding: 40px !important;
          color: #64748b;
          font-style: italic;
        }

        /* ---------- RESPONSIVE ---------- */
        @media (max-width: 768px) {
          .fee-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .header-actions {
            width: 100%;
            justify-content: space-between;
          }
          
          .table-controls {
            flex-direction: column;
            align-items: stretch;
          }

          .search-box {
            max-width: 100%;
          }

          .filters-group {
            justify-content: space-between;
          }
          
          .fee-table th, 
          .fee-table td {
            padding: 12px 15px;
          }
        }
      `}</style>

      <div className="fee-page">
        <div className="fee-container">
          
          {/* HEADER SECTION */}
          <div className="fee-header">
            <div>
              <h1>Fee Management</h1>
              <p>Track student fee payments, dues, and collection status</p>
            </div>
            <div className="header-actions">
              <button className="btn-primary">
                <i className="fa fa-plus"></i> Collect Fee
              </button>
            </div>
          </div>

          {/* STATS CARDS */}
          <div className="stats-grid">
            <div className="stat-card expected">
              <div className="stat-icon"><i className="fa fa-money"></i></div>
              <div className="stat-info">
                <span>Total Expected</span>
                <strong>{formatCurrency(totalExpected)}</strong>
              </div>
            </div>
            <div className="stat-card collected">
              <div className="stat-icon"><i className="fa fa-check-circle"></i></div>
              <div className="stat-info">
                <span>Total Collected</span>
                <strong>{formatCurrency(totalCollected)}</strong>
              </div>
            </div>
            <div className="stat-card pending">
              <div className="stat-icon"><i className="fa fa-exclamation-circle"></i></div>
              <div className="stat-info">
                <span>Total Pending</span>
                <strong>{formatCurrency(totalPending)}</strong>
              </div>
            </div>
            <div className="stat-card paid-count">
              <div className="stat-icon"><i className="fa fa-users"></i></div>
              <div className="stat-info">
                <span>Fully Paid</span>
                <strong>{paidCount} / {feeData.length}</strong>
              </div>
            </div>
          </div>

          {/* FILTER & SEARCH BAR */}
          <div className="table-controls">
            <div className="search-box">
              <i className="fa fa-search"></i>
              <input 
                type="text" 
                placeholder="Search by name or roll no..." 
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            
            <div className="filters-group">
              <div className="filter-box">
                <label>Class:</label>
                <select value={filterClass} onChange={(e) => setFilterClass(e.target.value)}>
                  <option value="All">All</option>
                  <option value="10-A">10-A</option>
                  <option value="10-B">10-B</option>
                  <option value="10-C">10-C</option>
                </select>
              </div>

              <div className="filter-box">
                <label>Status:</label>
                <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                  <option value="All">All</option>
                  <option value="Paid">Paid</option>
                  <option value="Partial">Partial</option>
                  <option value="Unpaid">Unpaid</option>
                </select>
              </div>
            </div>
          </div>

          {/* DATA TABLE */}
          <div className="table-responsive">
            <table className="fee-table">
              <thead>
                <tr>
                  <th>Roll No</th>
                  <th>Student Name</th>
                  <th>Class</th>
                  <th>Total Fee</th>
                  <th>Paid</th>
                  <th>Pending</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((student) => {
                    const pendingAmount = student.totalFee - student.paidAmount;
                    return (
                      <tr key={student.id}>
                        <td className="roll-col">{student.roll}</td>
                        <td className="name-col">
                          <div className="avatar">{student.name.charAt(0)}</div>
                          {student.name}
                        </td>
                        <td>{student.class}</td>
                        <td className="amount-col">{formatCurrency(student.totalFee)}</td>
                        <td className="amount-col" style={{ color: "#166534" }}>
                          {formatCurrency(student.paidAmount)}
                        </td>
                        <td className={`amount-col ${pendingAmount > 0 ? "pending-amt" : ""}`}>
                          {formatCurrency(pendingAmount)}
                        </td>
                        <td>
                          <span className={`status-badge ${getStatusColor(student.status)}`}>
                            {student.status}
                          </span>
                        </td>
                        <td>
                          <button className="btn-action" title="View Receipt">
                            <i className="fa fa-file-text-o"></i> Receipt
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className="no-data">No fee records found matching your criteria.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </>
  );
};

export default FeeManagement;